import { render, staticRenderFns } from "./OffenceTag.vue?vue&type=template&id=77dcb000&scoped=true&"
import script from "./OffenceTag.vue?vue&type=script&lang=js&"
export * from "./OffenceTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dcb000",
  null
  
)

export default component.exports